import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_STATUTORY_BONUS);
var axios_instance_statutory_deduction_override = get_axios_instance(api_variables.SERVICE_STATUTORY_DEDUCTION_OVERRIDE);
var axios_instance_statutory_deduction_override_bulk = get_axios_instance(api_variables.SERVICE_STATUTORY_DEDUCTION_OVERRIDE_BULK);

const state = {
    data: {},
    statutoryBonusData: {},
    overrideData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {
    set: (state, [payload, le_id]) => {
        if (le_id) {
            state.data[le_id] = payload;
            state.data = {...state.data }
        }
    },

    setOverrideData: (state, [payload, le_id]) => {
        if (le_id) {
            state.overrideData[le_id] = payload;
            state.overrideData = {...state.overrideData }
        }
    },

    statutoryBonus: (state, payload) => {
        state.statutoryBonusData = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }

}

const actions = {
    async fetchAll({ commit }, queryObj) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get('', {
                params: {...queryObj }
            });
            commit("setFetching", false);
            if (res.status == 200 || res.status == 201) {
                //console.log(res.data.payload.data.length)
                commit("set", [res.data.payload.data, le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchStatutoryDeductionOverride({ commit }, queryObj) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_statutory_deduction_override.get('', {
                params: {...queryObj }
            });
            commit("setFetching", false);
            if (res.status == 200 || res.status == 201) {
                //console.log(res.data.payload.data.length)
                commit("setOverrideData", [res.data.payload.data, le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                commit("statutoryBonus", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async createStatutoryDeductionOverride({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance_statutory_deduction_override.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                // commit("statutoryBonus", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, [payload, le_id]) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put('', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEntityById", [res.data, le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, le_id]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload.id, le_id]);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },


    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
